require('./bootstrap');

$(document).ready(function() {
    $('body').addClass('loaded');
    $('.aniview').AniView();
});